import { useState } from 'react'
import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'

const WA_NUM = '77772296225'

export function ConsultModal({ open, onClose, subtitle }) {
  const [nm,   setNm]   = useState('')
  const [msg,  setMsg]  = useState('')
  const [sent, setSent] = useState(false)

  if (!open) return null

  const handleClose = () => {
    onClose?.()
    setSent(false)
    setNm('')
    setMsg('')
  }

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) handleClose() }}
      style={{ position:'fixed', inset:0, background:'rgba(1,8,16,.93)', backdropFilter:'blur(14px)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}
    >
      <div style={{ background:'#0A1B2E', borderRadius:22, padding:28, maxWidth:380, width:'100%', border:'1px solid #1A3550' }}>
        {!sent ? (
          <>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
              <div>
                <div style={{ fontSize:18, fontWeight:800, color:'#fff' }}>Получить консультацию</div>
                {subtitle && (
                  <div style={{ fontSize:12.5, color:C.s3, marginTop:4, fontFamily:"'JetBrains Mono',monospace" }}>{subtitle}</div>
                )}
              </div>
              <button onClick={handleClose} style={{ background:'rgba(255,255,255,.06)', border:`1px solid ${C.line}`, borderRadius:9, padding:8, color:C.s2, cursor:'pointer' }}>
                <Ic n="x" s={16}/>
              </button>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:11 }}>
              <input
                style={{ background:'rgba(255,255,255,.05)', border:`1px solid ${C.line2}`, borderRadius:11, padding:'12px 16px', color:'#fff', fontSize:15, width:'100%', outline:'none', boxSizing:'border-box' }}
                placeholder="Ваше имя"
                value={nm}
                onChange={e => setNm(e.target.value)}
              />
              <textarea
                style={{ background:'rgba(255,255,255,.05)', border:`1px solid ${C.line2}`, borderRadius:11, padding:'12px 16px', color:'#fff', fontSize:14, width:'100%', outline:'none', resize:'none', lineHeight:1.6, fontFamily:'inherit', boxSizing:'border-box' }}
                placeholder="Ваш вопрос..."
                rows={3}
                value={msg}
                onChange={e => setMsg(e.target.value)}
              />
              <button
                className="btn btn-p"
                style={{ width:'100%', justifyContent:'center', marginTop:4 }}
                onClick={() => {
                  const text = `Здравствуйте, меня зовут ${nm || 'клиент'}. ${msg}`.trim()
                  window.open(`https://wa.me/${WA_NUM}?text=${encodeURIComponent(text)}`, '_blank')
                  setSent(true)
                }}
              >
                <Ic n="wa" s={16}/>Получить консультацию
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign:'center', padding:'24px 0' }}>
            <div style={{ width:58, height:58, borderRadius:'50%', background:'rgba(37,211,102,.12)', border:'1px solid #25d366', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', color:'#25d366' }}>
              <Ic n="wa" s={28}/>
            </div>
            <div style={{ fontSize:19, fontWeight:800, color:'#fff', marginBottom:8 }}>WhatsApp открыт!</div>
            <div style={{ fontSize:13, color:C.s3, marginBottom:16, lineHeight:1.5 }}>
              Сообщение заполнено — просто нажмите «Отправить» в WhatsApp.
            </div>
            <button className="btn btn-g" style={{ marginTop:4 }} onClick={handleClose}>Закрыть</button>
          </div>
        )}
      </div>
    </div>
  )
}
